var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.55,
    height: 32,
    viewBox: "0 0 32.55 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160341",
    "data-name": "Group 160341",
    transform: "translate(-720 -624)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1896",
    "data-name": "Rectangle 1896",
    width: 32,
    height: 32,
    transform: "translate(720 624)",
    fill: "#c9cacc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "email_report",
    "data-name": "email report",
    transform: "translate(720.82 624.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M.75,26.59v1.04a2.926,2.926,0,0,0,2.94,2.91H28.03a2.919,2.919,0,0,0,2.94-2.91V14.22a2.906,2.906,0,0,0-1.63-2.6L16.64,5.35a1.758,1.758,0,0,0-1.58,0L2.38,11.61a2.924,2.924,0,0,0-1.63,2.6v8.38",
    fill: "none",
    stroke: "#2a6bec",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M30.98,14.96V9.8a2.906,2.906,0,0,0-1.63-2.6L16.65.93a1.758,1.758,0,0,0-1.58,0L2.38,7.2A2.924,2.924,0,0,0,.75,9.8v5.28",
    fill: "none",
    stroke: "#2a6bec",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M26.13,25.88l-9.39-7.31a1.741,1.741,0,0,0-2.14,0L5.21,25.88m14.53-5.3,9.88-7.48m-27.9,0,10.1,7.63",
    fill: "none",
    stroke: "#2a6bec",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160342",
    "data-name": "Group 160342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M17.03,12.5a1.643,1.643,0,0,1-1.63,1.62,1.359,1.359,0,0,1-1.28-1.62,1.68,1.68,0,0,1,1.57-1.62,1.4,1.4,0,0,1,1.34,1.62Z",
    fill: "none",
    stroke: "#6d7077",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.98
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M17.03,15.77a3.617,3.617,0,0,1-1.6.29,3.2,3.2,0,0,1-3.24-3.56,3.969,3.969,0,0,1,3.87-3.56,2.981,2.981,0,0,1,3.26,3.39c-.13,1.45-1.05,1.87-1.54,1.78-.46-.08-.83-.49-.76-1.28l.17-1.95",
    fill: "none",
    stroke: "#6d7077",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.98
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    cx: 0.57,
    cy: 0.57,
    r: 0.57,
    transform: "translate(0.18 24.02)",
    fill: "#2a6bec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.203374ad3c817136ce1a506ed4abb9ee.svg";
export { ForwardRef as ReactComponent };